if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      initSwiper() {
        this.swiper = new Swiper(
          this.querySelector(".product-media-modal__content.swiper"),
          {
            loop: true,
            autoplay: false,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          }
        );
      }

      hide() {
        super.hide();
      }

      show(opener) {
        if (!this.swiper) this.initSwiper();
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        let ind = activeMedia.parentNode.getAttribute(
          "data-swiper-slide-index"
        );
        if (ind) {
          ind = parseInt(ind, 10);
          this.swiper.slideTo(ind, 0);
        }

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
      }
    }
  );
}
